import { useState } from "react";
import { ISelectCompanyProps } from "../FrontPageInterfaces";
import SelectProductCompany from "./SelectProductCompany";
import SelectExternalCompany from "./SelectExternalCompany";

export default function SelectCompany({ onSelect }: ISelectCompanyProps) {
  const [isProductDisabled, setIsProductDisabled] = useState(false);
  const [isExternalDisabled, setIsExternalDisabled] = useState(false);
  const [isProductDrowdownOpen, setIsProductDrowdownOpen] = useState(false);
  const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
  const hide = process.env.REACT_APP_HIDE === "true";

  const handleSelect = (
    type: "product" | "external",
    selectedKey: string | null,
    selectedLabel: string | null
  ) => {
    const newSelectedCompany =
      selectedKey === "deselect"
        ? null
        : {
            key: selectedKey || "",
            label: selectedLabel || "",
          };

    if (type === "product") {
      setIsExternalDisabled(selectedKey !== "deselect" && selectedKey !== null);
    } else if (type === "external") {
      setIsProductDisabled(selectedKey !== "deselect" && selectedKey !== null);
    }

    if (onSelect) {
      onSelect(newSelectedCompany, type === "product" ? true : false);
    }
  };

  return (
    <>
      <SelectProductCompany
        onSelect={(companykey, companyLabel) => {
          handleSelect("product", companykey, companyLabel);
        }}
        isDisabled={isProductDisabled}
        setIsDropdownOpen={setIsProductDrowdownOpen}
        isDropdownOpen={isCompanyDropdownOpen}
      />
      {!hide && (
        <SelectExternalCompany
          onSelect={(companykey, companyLabel) => {
            handleSelect("product", companykey, companyLabel);
          }}
          isDisabled={isExternalDisabled}
          setIsDropdownOpen={setIsCompanyDropdownOpen}
          isDropdownOpen={isProductDrowdownOpen}
        />
      )}
    </>
  );
}
